import { FC, useEffect, useState } from "react";
import {
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonContent,
  IonIcon,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers/rootReducer";
import {
  setActiveLoading,
  setModalCanalHide,
  setToast,
} from "../../actions/ui";
import {
  canalizacionStartAddNew,
  clearActiveCanalizacion,
  startCanalizacionUpdated,
} from "../../actions/canalizaciones";
import { Canalizacion } from "../../interfaces/Canalizacion";
import { closeOutline } from "ionicons/icons";

const initCanalizacion = {
  name: "",
};

export const CanalizacionScreen: FC = () => {
  const dispatch = useDispatch();
  const { activeCanalizacion } = useSelector(
    (state: RootState) => state.canalizacion
  );
  const [formValues, setFormValues] = useState(initCanalizacion);

  const { name } = formValues;

  useEffect(() => {
    if (activeCanalizacion) {
      const canalizacion = {
        name: activeCanalizacion.name,
      };
      setFormValues(canalizacion);
    } else {
      setFormValues(initCanalizacion);
    }
  }, [activeCanalizacion]);

  const handleInputChange = ({ target }) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };

  const canalizacion: Canalizacion = {
    id: "",
    name,
    user: {
      _id: "",
      name: "",
    },
  };

  const handleSumit = (e: any) => {
    e.preventDefault();
    if (name.length <= 1) {
      const toast = {
        title: "Error",
        msg: "El nombre es un campo obligatorio",
        color: "danger",
      };

      dispatch(setToast(toast));
      return;
    }
    dispatch(setActiveLoading());
    if (activeCanalizacion) {
      canalizacion.id = activeCanalizacion.id;
      canalizacion.user = activeCanalizacion.user;
      dispatch(startCanalizacionUpdated(canalizacion));
      dispatch(clearActiveCanalizacion());
    } else {
      dispatch(canalizacionStartAddNew(canalizacion));
    }
  };

  const setShowModal = () => {
    setFormValues(initCanalizacion);
    dispatch(clearActiveCanalizacion());
    dispatch(setModalCanalHide());
  };

  return (
    <>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonTitle>
            {" "}
            {activeCanalizacion ? "Actualizar" : "Registrar tipo"}
          </IonTitle>
          <IonButtons slot="end">
            <IonButton color="primary" onClick={setShowModal}>
              <IonIcon icon={closeOutline}></IonIcon>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="marca-container">
        <form onSubmit={handleSumit}>
          <IonItem>
            <IonLabel className="item-label" position="floating">
              Nombre
            </IonLabel>
            <IonInput
              type="text"
              name="name"
              value={name}
              onIonChange={handleInputChange}
              autocomplete="off"
              placeholder="Nombre"
            ></IonInput>
          </IonItem>
          <IonItem lines="none" className="marca-item">
            <IonButton slot="end" fill="clear" type="submit">
              Guardar
            </IonButton>
            <IonButton slot="end" fill="clear" onClick={setShowModal}>
              Cerrar
            </IonButton>
          </IonItem>
        </form>
      </IonContent>
    </>
  );
};
